












import { Component, Vue, Prop} from "@/common";

@Component({})
export default class TwItem extends Vue {
  @Prop({})
  private size!: number;

  @Prop({ default: false })
  private collapsed!: boolean;

  @Prop({ default: false })
  private showSplit!: boolean;

  @Prop({
    validator: value => {
      return ["top", "bottom", "left", "right", "center"].indexOf(value) !== -1;
    }
  })
  private region!: string;

  private direction: string = "";

  private height: number = this.size || 0;

  private width: number = this.size || 0;

  private currSplit: boolean = this.collapsed;

  private currSize: number = this.size;

  private hasMoved: boolean = false;

  private get splitClass(): string {
    let cls = ["splitter-pane-resizer"];

    cls.push(this.direction);

    cls.push(this.region);

    return cls.join(" ");
  }

  private get imgClass(): string {
    let cls = ["img"];
    this.currSplit ? cls.push("collapsed") : cls.push("expanded");
    return cls.join(" ");
  }

  private get itemStyle(): string {
    let _style = "overflow:hide;position:absolute;";

    let _topHeight = 0;
    let _bottomHeight = 0;

    let _leftWidth = 0;
    let _rightWidth = 0;

    const thisUid = this.$vnode.componentInstance["_uid"];

    this.$parent.$slots.default.forEach(value => {
      if (value.componentInstance) {
        if (value.componentInstance["_uid"] === thisUid) {
          _style += `${this.region}:0px;`;
          switch (this.region) {
            case "top":
            case "bottom":
              _style += `left:${_leftWidth}px;`;
              _style += `height:${this.height}px;`;
              if (_leftWidth + _rightWidth > 0) {
                _style += `width:calc(100% - ${_leftWidth + _rightWidth}px);`;
              } else {
                _style += `width:100%;`;
              }
              break;
            case "left":
            case "right":
              _style += `top:${_topHeight}px;`;
              _style += `width:${this.width}px;`;
              if (_topHeight + _bottomHeight > 0) {
                _style += `height:calc(100% - ${_topHeight +
                  _bottomHeight}px);`;
              } else {
                _style += `height:100%;`;
              }
              break;
          }
        } else {
          switch (value.componentOptions.propsData["region"]) {
            case "top":
              _topHeight = parseInt(value.componentInstance["height"] || 0, 10);
              break;
            case "bottom":
              _bottomHeight = parseInt(
                value.componentInstance["height"] || 0,
                10
              );
              break;
            case "left":
              _leftWidth = parseInt(value.componentInstance["width"] || 0, 10);
              break;
            case "right":
              _rightWidth = parseInt(value.componentInstance["width"] || 0, 10);
              break;
          }
        }
      }
    });

    if (this.region === "center") {
      _style += `left:${_leftWidth}px;top:${_topHeight}px;width:calc(100% - ${_leftWidth +
        _rightWidth}px);height:calc(100% - ${_topHeight + _bottomHeight}px);`;
    }

    return _style;
  }

  private get containerStyle(): string {
    let style = "position:absolute;overflow:auto;";
    let height = "height:100%;";
    let width = "width:100%;";
    if (this.showSplit) {
      if (this.direction === "vertical") {
        style += this.region === "top" ? "bottom:5px;" : "top:5px;";
        height = "height:calc(100% - 5px);";
      } else if (this.direction === "horizontal") {
        style += this.region === "left" ? "right:5px;" : "left:5px;";
        width = "width:calc(100% - 5px);";
      }
    }
    return style + height + width;
  }

  splitClick() {
    if (!this.hasMoved) {
      this.currSplit = !this.currSplit;
      this.setSplitClick();
    }
  }

  setSplitClick() {
    if (this.currSplit) {
      if (this.direction === "vertical") {
        this.currSize = this.height;
        this.height = 5;
      } else {
        this.currSize = this.width;
        this.width = 5;
      }
    } else {
      if (this.direction === "vertical") {
        this.height = this.currSize;
      } else {
        this.width = this.currSize;
      }
    }
  }

  onMouseDown(e) {
    if (!this.currSplit) {
      (this.$parent as any).splitDown(e, this);
    }
  }

  mounted() {
    if (this.region === "top" || this.region === "bottom") {
      this.direction = "vertical";
    } else if (this.region === "left" || this.region === "right") {
      this.direction = "horizontal";
    }
    this.setSplitClick();
  }
}
